import { MessageCircle, Instagram, Linkedin, MapPin } from "lucide-react";
import { Reveal } from "../landing/shared";
import { SITE, waLink } from "@/config";

const Contact = () => (
  <section data-testid="contact-section" className="bg-white py-14 sm:py-20">
    <div className="mx-auto max-w-4xl px-4 sm:px-6">
      <Reveal className="text-center">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Contact</p>
      </Reveal>
      <Reveal delay={0.05} className="text-center">
        <h2 className="mt-3 font-serif text-3xl leading-[1.12] tracking-tight text-navy sm:text-4xl" data-testid="contact-headline">
          Questions? Talk to Us.
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="text-center">
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-charcoal/80">
          Order support, counselling booking, ya koi bhi sawaal — humein message karein. Hum jaldi reply karte hain.
        </p>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Reveal delay={0.12} className="h-full">
          <div className="flex h-full flex-col items-center rounded-3xl border border-navy/10 bg-ivory p-7 text-center" data-testid="contact-whatsapp-card">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-wa/15">
              <MessageCircle className="h-5 w-5 text-wa-dark" />
            </span>
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-charcoal/50">WhatsApp</p>
            <p className="mt-1 font-serif text-2xl font-semibold text-navy" data-testid="contact-phone">
              +91 72085 46240
            </p>
            <a
              data-testid="contact-whatsapp-button"
              href={waLink("Hi Dr. Burhan, I have a question about the Medlinkx Constipation Care Kit.")}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-wa px-7 py-3 text-xs font-bold uppercase tracking-[0.14em] text-[#063A2C] transition-all duration-300 hover:-translate-y-0.5 hover:bg-wa-dark hover:text-white"
            >
              Chat on WhatsApp
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.2} className="h-full">
          <div className="flex h-full flex-col items-center rounded-3xl border border-navy/10 bg-ivory p-7 text-center" data-testid="contact-instagram-card">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy/10">
              <Instagram className="h-5 w-5 text-navy" />
            </span>
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-charcoal/50">Instagram</p>
            <p className="mt-1 font-serif text-2xl font-semibold text-navy" data-testid="contact-instagram-handle">
              @drburhanshaikh
            </p>
            <a
              data-testid="contact-instagram-button"
              href={SITE.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-navy px-7 py-3 text-xs font-bold uppercase tracking-[0.14em] text-ivory transition-all duration-300 hover:-translate-y-0.5 hover:bg-navy-deep"
            >
              Follow on Instagram
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.28} className="h-full">
          <div className="flex h-full flex-col items-center rounded-3xl border border-navy/10 bg-ivory p-7 text-center" data-testid="contact-linkedin-card">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy/10">
              <Linkedin className="h-5 w-5 text-navy" />
            </span>
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-charcoal/50">LinkedIn</p>
            <p className="mt-1 font-serif text-2xl font-semibold text-navy" data-testid="contact-linkedin-name">
              Dr. Burhan Shaikh
            </p>
            <a
              data-testid="contact-linkedin-button"
              href={SITE.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center justify-center gap-2 rounded-full border-2 border-navy/70 px-7 py-3 text-xs font-bold uppercase tracking-[0.14em] text-navy transition-all duration-300 hover:-translate-y-0.5 hover:bg-navy hover:text-ivory"
            >
              Connect on LinkedIn
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.36} className="h-full">
          <div className="flex h-full flex-col items-center rounded-3xl border border-navy/10 bg-ivory p-7 text-center" data-testid="contact-address-card">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gold/15">
              <MapPin className="h-5 w-5 text-gold" />
            </span>
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-charcoal/50">Clinic Address</p>
            <p className="mt-1 text-sm font-semibold leading-relaxed text-navy" data-testid="contact-address">
              Healing Hands Clinic,
              <br />
              Mehta 531 Complex, Ashram Road,
              <br />
              Ahmedabad - 380006, Gujarat
            </p>
            <a
              data-testid="contact-directions-button"
              href={SITE.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center justify-center gap-2 rounded-full border-2 border-gold/60 px-7 py-3 text-xs font-bold uppercase tracking-[0.14em] text-navy transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-navy"
            >
              Get Directions
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Contact;
